export const AUTH_USER = 'purport-authUser';

export default AUTH_USER;
